import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=7085b584&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=ts&"
export * from "./BarChart.vue?vue&type=script&lang=ts&"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=7085b584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7085b584",
  null
  
)

export default component.exports